"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappedSubject = void 0;
const rxjs_1 = require("rxjs");
class MappedSubject extends rxjs_1.BehaviorSubject {
    constructor(_observable, initial) {
        super(initial);
        this._observable = _observable;
        this._subscription = null;
        this._refCount = 0;
    }
    _subscribe(subscriber) {
        // tslint:disable-line function-name
        if (!this._subscription) {
            this._subscription = this._observable.subscribe(v => this._onValue(v));
        }
        this._refCount = this._refCount + 1;
        const sub = new rxjs_1.Subscription(() => {
            this._refCount = this._refCount - 1;
            if (this._refCount <= 0 && this._subscription) {
                this._subscription.unsubscribe();
                this._subscription = null;
            }
        });
        sub.add(super._subscribe(subscriber));
        return sub;
    }
    unsubscribe() {
        if (this._subscription) {
            this._subscription.unsubscribe();
            this._subscription = null;
        }
        this._refCount = 0;
        super.unsubscribe();
    }
}
exports.MappedSubject = MappedSubject;
